import React from 'react';

import { CancelPayment } from '..';

import {
  LastPaymentWrap,
  LastPaymentAmtText,
  LastPaymentDateWrap,
  LastPaymentSuccessIcon,
  LastPaymentDate,
  NextPaymentWrap,
  NextPaymentSectionTitle,
  NextPaymentSectionTotalAmt,
  NextPaymentAutoDraftText,
  NextPaymentAmtDisclaimer,
  PastDuePill,
  PastDuePillIcon,
  PastDuePillText,
  LastDayToPayText,
  FooterButtonsWrap
} from './NextPaymentSectionStyles';

import SuccessSrc from '../../assets/images/Success.svg';
import WarningSrc from '../../assets/images/AlertIcon.svg';
import { PAYMENT_INFO_GET_LAST_DAY_TO_PAY_DETAILS_account_items } from '../paymentInfo/graphql/__generated__/PAYMENT_INFO_GET_LAST_DAY_TO_PAY_DETAILS';
import { formatDate } from '../../util/formatters';
import moment from 'moment-timezone';


interface LastPaymentProps {
  lastPaymentAmt: string | JSX.Element;
  lastPaymentDate: string | number | Date | null | undefined;
}

export const LastPaymentSection = ({
  lastPaymentAmt,
  lastPaymentDate
}: LastPaymentProps) => {
  return (
    <LastPaymentWrap>
      <LastPaymentAmtText>Last Payment {lastPaymentAmt}</LastPaymentAmtText>
      <LastPaymentDateWrap>
        {lastPaymentDate && lastPaymentDate !== '-' && (
          <LastPaymentSuccessIcon src={SuccessSrc} />
        )}
        <LastPaymentDate>Received on {lastPaymentDate}</LastPaymentDate>
      </LastPaymentDateWrap>
    </LastPaymentWrap>
  );
};

interface Props {
  totalAmt: string;
  makePayment: JSX.Element[] | undefined | any;
  lastDayToPayDetails: PAYMENT_INFO_GET_LAST_DAY_TO_PAY_DETAILS_account_items;
  dueDate: string;
}

const NextPaymentSection = ({ totalAmt, makePayment, lastDayToPayDetails, dueDate}: Props) => {
  const dueAmt = lastDayToPayDetails?.next_payment_no_mortgagee_billed?.pastDueAmount;
  const isNotPastDue = !lastDayToPayDetails?.lastDayToPay?.hasPastDue ||(dueAmt && ['0', '-', '0.0'].includes(dueAmt)); 
  const transEffectiveDate = lastDayToPayDetails?.lastDayToPay?.policy?.trans_effective_date;
  const currentDate = moment.tz('America/New_York').format('YYYY-MM-DD');
  const diff = transEffectiveDate && moment.tz(transEffectiveDate, 'America/New_York').diff(currentDate, 'days');
  const showPastDueDate = !isNotPastDue && (diff && diff > 0 && lastDayToPayDetails?.lastDayToPay?.policy?.status?.toLowerCase().includes('canceling'));
  return (
    <NextPaymentWrap>
      <NextPaymentSectionTitle>Next Payment</NextPaymentSectionTitle>
      <NextPaymentSectionTotalAmt>{totalAmt}</NextPaymentSectionTotalAmt>
      <NextPaymentAutoDraftText> 
        on {dueDate}
      </NextPaymentAutoDraftText>
      <NextPaymentAmtDisclaimer>
        Amount is inclusive of all the policies.
      </NextPaymentAmtDisclaimer>
      {!isNotPastDue && (
        <div>
          <PastDuePill>
            <PastDuePillIcon src={WarningSrc} />
            <PastDuePillText>Past Due</PastDuePillText>
          </PastDuePill>
          <LastDayToPayText>
            There is a past due amount of <b>${lastDayToPayDetails?.next_payment_no_mortgagee_billed?.pastDueAmount}</b> on the account. {showPastDueDate && <span>The policy
            will cancel if the payment is not received on or before{' '}
            <b>{formatDate(transEffectiveDate)} at 12:01 AM</b>.</span>}
          </LastDayToPayText>
        </div>
      )}

      <FooterButtonsWrap>
        {makePayment}
        <CancelPayment />
      </FooterButtonsWrap>
    </NextPaymentWrap>
  );
};

export default NextPaymentSection;
